/* eslint-disable import/no-anonymous-default-export */
import { getConfig } from "./services/config.service";

// Last-resort fallback. Real value comes from /api/v1/ClientConfig at runtime so the SPA
// always targets the same Okta tenant the backend trusts.
const ISSUER_FALLBACK = "https://bankersfinancialcorp.okta.com/oauth2/default";

/**
 * Gets the Okta configuration using runtime config values.
 * The config service must be initialized before this is called (done in index.js).
 */
const getOktaConfig = () => {
  const runtimeConfig = getConfig();
  return {
    clientId: runtimeConfig.oktaClientId || "0oajoykvouvxQ0CT34h7",
    issuer: runtimeConfig.oktaIssuer || ISSUER_FALLBACK,
    redirectUri: "", // Set dynamically in App.js based on window.location.origin
    scopes: ["openid", "profile", "offline_access"],
    // Security: Use PKCE for additional protection against authorization code interception
    pkce: true,
    // Security: Use sessionStorage instead of localStorage for token storage
    // sessionStorage is cleared when the browser tab is closed, reducing exposure window
    tokenManager: {
      storage: 'sessionStorage',
      autoRenew: true,
      expireEarlySeconds: 120,
    },
  };
};

export default {
  get oidc() {
    return getOktaConfig();
  },
};
